import React, { Component } from 'react'
import DialogWrapper from '../../../../components/DialogWrapper'
import { Button, Typography, Box } from '@mui/material';
import { ALERT_SEVERITY } from '../../../../components/AlertDisplay2';
import EntitySelectionContent from '../../../../components/EntitySelection/EntitySelectionContent';
import { APIData } from '../../../../constants/APIAdresses';
import CustomLightButton from '../../../../components/CustomLightButton';
import { sharePromoCodes } from '../../../../APIHelper';
const PROMOCODE_BATCH_SIZE = 10; // max number of promo codes to generate / share in one batch
export default class ShareCodeDialog extends Component {
    state = {
        selectedPromoCodes: []
    }
    async shareSelectedCodes() {
        const res = await sharePromoCodes(this.props.shopId, this.state.selectedPromoCodes.map(x => x.id))
        if (res != null) {
            this.props.showAlert("Aktionscodes erfolgreich geteilt!", ALERT_SEVERITY.SUCCESS);
            this.props.onClose(true); // pass true to indicate that sharing was successful and parent component should refresh data
        } else {
            this.props.showAlert("Fehler beim Teilen der Aktionscodes. Bitte versuche es erneut.", ALERT_SEVERITY.ERROR);
        }
    }
    render() {
        const { shopId, companyId, open, onClose, showAlert } = this.props;
        return (
            <DialogWrapper
                actions={
                    <>
                        <CustomLightButton style={{ flex: 1 }} icon={require('../../../../assets/icons/voucher.png')} label="Aktionscodes Teilen" onPress={() => this.shareSelectedCodes()} disabled={this.state.selectedPromoCodes.length === 0} />
                    </>
                }
                maxWidth='xl' title="📤 Aktionscode Teilen" open={open} onClose={() => onClose()} >
                <EntitySelectionContent
                    showAlert={showAlert}
                    // title="Aktionscode Selektieren?"
                    // icon={require('../../../../assets/icons/voucher.png')}
                    apiEndpoint={(page, ipp, search) => `${APIData.SHOP}/multiShopPromocodes?page=${page}&ipp=${ipp}${search != null && search.length > 3 ? `&search=${encodeURIComponent(search)}` : ""}`}
                    method="POST"
                    body={{ shopIds: this.props.shopId ? [this.props.shopId] : [] }}
                    keyFieldName="id"
                    additionalKeysToAdd={["code"]}
                    searchPlaceholder="Suche"
                    value={this.state.selectedPromoCodes}
                    multipleSelection={true}
                    onChange={(newSelected) => {
                        console.log("Selected promo codes: ", newSelected);
                        if (newSelected.length > PROMOCODE_BATCH_SIZE) {
                            showAlert(`Du kannst nicht mehr als ${PROMOCODE_BATCH_SIZE} Aktionscodes auf einmal teilen.`, ALERT_SEVERITY.WARNING);
                            return;
                        }
                        this.setState({ selectedPromoCodes: newSelected });
                    }}
                    renderChipContent={(item) => {
                        return (
                            <Box sx={{ flex: 1, minWidth: 0 }}>
                                <Typography
                                    sx={{
                                        fontSize: 14,
                                        color: "#353535",
                                        wordBreak: "break-word",
                                    }}
                                >
                                    <Box component="span" sx={{ fontWeight: 600 }}>
                                        Code:
                                    </Box>{" "}
                                    {item.code}{" "}
                                    <Box component="span" sx={{ fontWeight: 600 }}>
                                        (ID:
                                    </Box>{" "}
                                    {item.id})
                                </Typography>
                            </Box>
                        );
                    }}
                // onClose={() => {}}
                />
                {/* <Typography>Share Code Dialog - Shop: {shopId}, Company: {companyId}</Typography> */}
                {/* <Button onClick={() => showAlert('Test Alert', ALERT_SEVERITY.WARNING)}>Test Alert</Button> */}
            </DialogWrapper>
        )
    }
}

// export default ShareCodeDialog
